module.exports = __webpack_public_path__ + "img/img24.6d68c9cc.png";